<template>
    <div class="quickpay-provider-card" @click="handleCardClick">
        <div class="quickpay-provider-card__header">
            <img :src="provider.logo" :alt="provider.name" class="quickpay-provider-card__logo" />
            <CompassTag
                v-if="provider.hasError"
                :color="CompassEnums.TagColorType.ORANGE"
                icon="warning"
                :size="CompassEnums.TagSize.SMALL"
            >
                {{ translations.error }}
            </CompassTag>
            <CompassTag
                v-else-if="provider.isConnected"
                :color="CompassEnums.TagColorType.GREEN"
                icon="success-circle"
                :size="CompassEnums.TagSize.SMALL"
            >
                {{ translations.connected }}
            </CompassTag>
        </div>
        <h4 class="quickpay-provider-card__name typographies-paragraph-medium-semibold">
            {{ provider.name }}
        </h4>
        <p class="quickpay-provider-card__description typographies-paragraph-medium-regular">
            {{ provider.description }}
        </p>
        <div class="quickpay-provider-card__footer">
            <CompassButton
                v-if="provider.isConnected"
                :label="translations.configure"
                :type="CompassEnums.ButtonType.TERTIARY"
                leftIcon="settings-fill"
                class="quickpay-provider-card__configure-button"
            />
            <CompassButton
                v-else
                :label="translations.connect"
                :type="CompassEnums.ButtonType.TERTIARY"
                class="quickpay-provider-card__connect-button"
            />
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';

const props = defineProps({
    provider: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['connect', 'configure']);
const $t = inject('$t');

const translations = {
    connected: $t.__('common.labels.connected'),
    error: $t.__('quickpay.settings.paymentPartners.connectionError'),
    configure: $t.__('common.actions.configure'),
    connect: $t.__('common.actions.connect'),
};

const handleCardClick = () => {
    if (props.provider.isConnected) {
        emit('configure', props.provider.id);
    } else {
        emit('connect', props.provider.id);
    }
};
</script>

<style lang="scss" scoped>
.quickpay-provider-card {
    display: flex;
    flex-direction: column;
    margin-top: var(--spacing-0);
    padding: var(--spacing-3);
    background: var(--colors-common-background-default);
    border-radius: var(--spacing-1);
    box-shadow: var(--elevation-1);
    cursor: pointer;
    transition: transform 0.2s ease;
    min-height: 216px;
    flex: 1 1 0;

    &:hover {
        transform: translateY(calc(-1 * var(--spacing-0)));

        :deep(.compass-button--tertiary) {
            background-color: var(--colors-common-background-primary-lightest-alt);
            color: var(--colors-common-text-primary-hover);
        }
    }
    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-bottom: var(--spacing-3);
    }
    &__logo {
        height: 40px;
        width: 40px;
        object-fit: contain;
    }
    &__name {
        width: 100%;
        margin: 0 0 var(--spacing-1);
        color: var(--colors-common-text-standard-default);
    }
    &__description {
        width: 100%;
        margin: 0 0 var(--spacing-1);
        color: var(--colors-common-text-subtle-default);
        flex: 1;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
    &__configure-button,
    &__connect-button {
        width: 100%;
    }
}
</style>
